export enum fileTypes {
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
}
